import {__} from '@wordpress/i18n';

const languages = [
    {value: "af", label: __("Afrikaans")},
    {value: "sq", label: __("Albanian")},
    {value: "am", label: __("Amharic")},
    {value: "ar", label: __("Arabic")},
    {value: "hy", label: __("Armenian")},
    {value: "az", label: __("Azerbaijani")},
    {value: "eu", label: __("Basque")},
    {value: "be", label: __("Belarusian")},
    {value: "bn", label: __("Bengali")},
    {value: "bs", label: __("Bosnian")},
    {value: "bg", label: __("Bulgarian")},
    {value: "my", label: __("Burmese")},
    {value: "ca", label: __("Catalan")},
    {value: "zh", label: __("Chinese")},
    {value: "hr", label: __("Croatian")},
    {value: "cs", label: __("Czech")},
    {value: "da", label: __("Danish")},
    {value: "nl", label: __("Dutch")},
    {value: "en", label: __("English")},
    {value: "et", label: __("Estonian")},
    {value: "fa", label: __("Farsi")},
    {value: "fi", label: __("Finnish")},
    {value: "fr", label: __("French")},
    {value: "gl", label: __("Galician")},
    {value: "ka", label: __("Georgian")},
    {value: "de", label: __("German")},
    {value: "el", label: __("Greek")},
    {value: "gu", label: __("Gujarati")},
    {value: "iw", label: __("Hebrew")},
    {value: "hi", label: __("Hindi")},
    {value: "hu", label: __("Hungarian")},
    {value: "is", label: __("Icelandic")},
    {value: "id", label: __("Indonesian")},
    {value: "it", label: __("Italian")},
    {value: "ja", label: __("Japanese")},
    {value: "kn", label: __("Kannada")},
    {value: "kk", label: __("Kazakh")},
    {value: "km", label: __("Khmer")},
    {value: "ko", label: __("Korean")},
    {value: "ky", label: __("Kyrgyz")},
    {value: "lo", label: __("Lao")},
    {value: "lv", label: __("Latvian")},
    {value: "lt", label: __("Lithuanian")},
    {value: "mk", label: __("Macedonian")},
    {value: "ms", label: __("Malay")},
    {value: "ml", label: __("Malayalam")},
    {value: "mr", label: __("Marathi")},
    {value: "mn", label: __("Mongolian")},
    {value: "ne", label: __("Nepali")},
    {value: "no", label: __("Norwegian")},
    {value: "pl", label: __("Polish")},
    {value: "pt", label: __("Portuguese")},
    {value: "pa", label: __("Punjabi")},
    {value: "ro", label: __("Romanian")},
    {value: "ru", label: __("Russian")},
    {value: "sr", label: __("Serbian")},
    {value: "si", label: __("Sinhalese")},
    {value: "sk", label: __("Slovak")},
    {value: "sl", label: __("Slovenian")},
    {value: "es", label: __("Spanish")},
    {value: "sw", label: __("Swahili")},
    {value: "sv", label: __("Swedish")},
    {value: "ta", label: __("Tamil")},
    {value: "te", label: __("Telugu")},
    {value: "th", label: __("Thai")},
    {value: "tr", label: __("Turkish")},
    {value: "uk", label: __("Ukrainian")},
    {value: "ur", label: __("Urdu")},
    {value: "uz", label: __("Uzbek")},
    {value: "vi", label: __("Vietnamese")},
    {value: "zu", label: __("Zulu")}
]
export default languages;